import React from 'react';
import { Redirect } from 'react-router-dom';

// Sends the visitor of a gated route (client-side) to `redirectTo`, with the same redirected/from/reason/pageName query
// that server/ssr.js adds, so the target page shows the same "no access" toast (see handleRedirectMessage in toast.js).
// App.js passes those values in `locationSearch` (the query string it builds for a getRedirectComponent route).
const RedirectToPath = ({ redirectTo = '/', locationSearch = {} }) => {
    const incoming = new URLSearchParams(locationSearch.search || '');
    const search = new URLSearchParams({
        redirected: 'true',
        from: (incoming.get('from') || '').trim(),
        reason: (incoming.get('reason') || '').trim(),
        pageName: (incoming.get('pageName') || '').trim()
    });

    return <Redirect to={{ pathname: redirectTo, search: `?${search.toString()}` }} />;
};

export default RedirectToPath;
